import styled from "@emotion/styled";
import { IStyledComponentProps } from "../../../theme/theme.types";

const SearchResultsList = styled.ul<IStyledComponentProps>`
  &.search-results-list {
    list-style: none;
    padding: 0;

    @media (max-width: ${(props) =>
        props.theme.utils.getThemeBreakpoint("tablet")}) {
      /* padding-bottom: 100px; */
    }
  }
`;
const ResultsListItem = styled.li<IStyledComponentProps>`
  &.results-list-item {
    padding: 8px 0 8px 12px;
    @media (max-width: ${(props) =>
        props.theme.utils.getThemeBreakpoint("tablet")}) {
      /* padding-bottom: 100px; */
    }
  }
`;

const ResultsContainer = styled.div<IStyledComponentProps>`
  &.results-container {
    display: flex;
    svg {
      width: 50px;
      height: 50px;
    }
  }
`;

const NoResultsContainer = styled.div<IStyledComponentProps>`
  &.no-results-container {
    .icon-container {
      background-color: ${(props) => props.theme.colors.alerts.secondary};
      border-radius: 50%;
      width: 80px;
      height: 80px;
      margin: 12px auto;
      img {
        width: 65px;
        height: 65px;
        margin: 8px;
      }
    }

    p {
      font-family: ${(props) => props.theme.fontFamilies.semiBold};
      font-size: 18px;
      text-align: center;
    }
  }
`;

const ResultsContent = styled.div<IStyledComponentProps>`
  &.results-content {
    margin-left: 10px;
    width: 100%;
    p {
      margin-bottom: 0;
      &.notification-id {
        color: ${(props) => props.theme.colors.essential.grayDark};
      }
    }

    .results-header {
      display: flex;
      width: 100%;
      justify-content: space-between;
      div {
        &.status {
          font-family: ${(props) => props.theme.fontFamilies.semiBold};
          &.reported {
            color: ${(props) => props.theme.colors.alerts.secondary};
          }
          &.not-reported {
            color: ${(props) => props.theme.colors.brand.primary};
          }
          &.extended-repair {
            color: ${(props) =>
              props.theme.colors.mapMarkers.extendedRepairStroke};
          }
        }
        &.reported-date {
          align-self: center;
          color: ${(props) => props.theme.colors.essential.grayDark};
          font-size: 12px;
        }
      }
    }
  }
`;

export default {
  SearchResultsList,
  ResultsListItem,
  ResultsContainer,
  NoResultsContainer,
  ResultsContent,
};
